<a routerLink="/" class="bpa-logo">
    <div class="bpa-logo-top">b</div>
    <div class="bpa-logo-bottom">pa</div>
</a>
